import { Data, NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { reaction } from 'mobx';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';
import ManageSecurityTransferComponentVM from '../components/ManageSecurityTransferComponentVM';
import CreateSecurityTransferCommand from '../Models/Commands/CreateSecurityTransferCommand';
import UpdateSecurityTransferCommand from '../Models/Commands/UpdateSecurityTransferCommand';
import SecurityTransferLookup from '../Models/Lookups/SecurityTransferLookup';
import SecurityTransferSearchCriteria from '../Models/Queries/SecurityTransferSearchCriteria';

@NeoModel
export default class SecurityTransfersVM extends Views.ViewModelBase {

    constructor(
        public securityTransferApiClient = AppService.get(Types.ApiClients.SecurityTransfersApiClient),
        
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService)) {
        super(taskRunner);
    }

    public showManageSecurityTransferComponent: boolean = false;
    public showDeleteSecurityTransferModal: boolean = false;
    public securityTransferSearchCritera = new SecurityTransferSearchCriteria();
    public deletingSecurityTransfer = new SecurityTransferLookup();
    public manageSecurityTransferComponentVM = new ManageSecurityTransferComponentVM();

    public pageManager = new Data.PageManager(this.securityTransferSearchCritera, SecurityTransferLookup,
        this.securityTransferApiClient.getPagedSecurityTransfers, {
            pageSize: 10,
            sortAscending: false,
            fetchInitial: true,
            initialTaskRunner: this.taskRunner
        });

    public async initialise() {
        reaction(() => this.securityTransferSearchCritera.searchCriteria, () => this.pageManager.refreshData(), {fireImmediately: false, delay: 650 });
        await this.securityTransferApiClient.getPagedSecurityTransfers({
            pageSize: 10,
        });
    }

    public async addSecurityTransfer() {
        this.showManageSecurityTransferComponent = true;
        await this.manageSecurityTransferComponentVM.loadFileGroupings();
    }

    public cancel() {
        this.manageSecurityTransferComponentVM.managedSecurityTransfer = new SecurityTransferLookup();
        this.showManageSecurityTransferComponent = false;
    }

    public cancelDeleteSecurityTransfer() {
        this.manageSecurityTransferComponentVM.managedSecurityTransfer = new SecurityTransferLookup();
        this.showDeleteSecurityTransferModal = false;
    }

    public async clearSearch() {
        this.securityTransferSearchCritera.meta.searchCriteria.value = "";
        await this.pageManager.refreshData();
    }

    public async deleteSecurityTransfer() {
        if (this.deletingSecurityTransfer.isDeletedInd === true) {
            this.taskRunner.run(async () => {
                var response = await this.securityTransferApiClient.updateSecurityTransfer((this.mapSecurityTransferToUpdateCommand(this.deletingSecurityTransfer)!.toJSObject()))
                if (response.data.success) {
                    this.showDeleteSecurityTransferModal = false;
                    NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SecurityTransferDeleted, NotificationDuration.Standard);
                    await this.pageManager.refreshData();
                }
                else {
                    NotifyUtils.addSuccess(TextConstants.Titles.Error, TextConstants.Notifications.FailedSubmission, NotificationDuration.Long);
                    this.cancelDeleteSecurityTransfer();
                }
            });
        }
    }

    public displayDeleteSecurityTransferModal(securityTransferLookup: SecurityTransferLookup) {
        this.showDeleteSecurityTransferModal = true;
        this.deletingSecurityTransfer = new SecurityTransferLookup();
        this.deletingSecurityTransfer.mapFrom(securityTransferLookup).toJSObject();
        this.deletingSecurityTransfer.isDeletedInd = true;
    }

    public async editSecurityTransfer(securityTransferLookup: SecurityTransferLookup) {
        this.manageSecurityTransferComponentVM.managedSecurityTransfer.mapFrom(securityTransferLookup).toJSObject();
        await this.manageSecurityTransferComponentVM.initialise();
        this.showManageSecurityTransferComponent = true;
    }

    private mapSecurityTransferToCreateCommand(securityTransferLookup: SecurityTransferLookup ) {
        var command = new  CreateSecurityTransferCommand().mapFrom(securityTransferLookup);
        command.fileGroupingIDFrom = securityTransferLookup.staticServiceProviderFileGroupingIDFrom;
        command.fileGroupingIDTo = securityTransferLookup.staticServiceProviderFileGroupingIDTo;
        return command;
    }

    private mapSecurityTransferToUpdateCommand(securityTransferLookup: SecurityTransferLookup) {
        var command = new UpdateSecurityTransferCommand().mapFrom(securityTransferLookup);
        command.fileGroupingIDFrom = securityTransferLookup.staticServiceProviderFileGroupingIDFrom;
        command.fileGroupingIDTo = securityTransferLookup.staticServiceProviderFileGroupingIDTo;
        return command;
    }

    public async saveSecurityTransfer() {
        this.taskRunner.run(async () => {
            var response = this.manageSecurityTransferComponentVM.managedSecurityTransfer.securityTransferID > 0
                ? await this.securityTransferApiClient.updateSecurityTransfer((this.mapSecurityTransferToUpdateCommand(this.manageSecurityTransferComponentVM.managedSecurityTransfer)!.toJSObject()))
                : await this.securityTransferApiClient.createSecurityTransfer((this.mapSecurityTransferToCreateCommand(this.manageSecurityTransferComponentVM.managedSecurityTransfer)!.toJSObject()));

            if (response.data.success) {
                NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.SecurityTransferSaved, NotificationDuration.Standard);
                await this.pageManager.refreshData();
            }
            else {
                NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger" as any, NotificationDuration.Long);
            }
            this.manageSecurityTransferComponentVM.managedSecurityTransfer = new SecurityTransferLookup();
            this.showManageSecurityTransferComponent = false;
        });
    }
}